module.exports = __webpack_public_path__ + "static/fonts/iconfont.496808e8.woff2";